
if(window.location.href.includes('/product')){
  
 // REDIRECT TO CART
  var redirectEnabled = false;
  
  jQuery( document ).ready(function() {
    
    if(window.innerWidth < 768 && redirectEnabled){
      jQuery('body').addClass('alexnova-redirect-enabled');
      jQuery('.add-to-cart').click(function(e){
        var cartCount = $('.cart-count-number').text();
          var x = 0;
        var timer = setInterval(function(){
          if(cartCount != $('.cart-count-number').text() || x > 50) {
             window.location.href = '/cart';
             clearInterval(timer);
          }
        x++;
        }, 50);
    });


    }
    
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
  
  Element.prototype.appendBefore = function(element) {
    element.parentNode.insertBefore(this, element);
};
  
  var addToCart = jQuery('.add_to_cart').eq(0);
  
  if(document.getElementsByClassName('alexnova-button-container').length == 0){
    var moreOptionsBtn = document.createElement('div');
    moreOptionsBtn.className = "alexnova-moreOptions-btn";
    moreOptionsBtn.innerHTML = "BUY NOW";
    var btnContainer = document.createElement('div');
    btnContainer.className = "alexnova-button-container";
    btnContainer.id = 'alexnova-btn-cont-id';
    var y = document.getElementsByClassName('add-to-cart');
    btnContainer.appendAfter(y[0]);   
   
	btnContainer.appendChild(moreOptionsBtn);
    
  }
  

 function checkIfDisabled(){
   
    return setTimeout(function(){ 
     if(jQuery('.alexnova-add-to-cart').length){
      jQuery('.alexnova-moreOptions-btn').removeClass('alexandnova-moreOptions-disabled');
     
       return false;
    }
    else{
     
      jQuery('.alexnova-moreOptions-btn').addClass('alexandnova-moreOptions-disabled');
             return true;
    }
}, 250);
    
     
};
 checkIfDisabled();
jQuery('.alexnova-moreOptions-btn').click(function(){
  if(!checkIfDisabled() || !jQuery(this).hasClass('alexandnova-moreOptions-disabled')){
  
    jQuery('.shopify-payment-button__more-options').eq(0).click();
  }
  else{
    jQuery('.product-smart-payments .add-to-cart').eq(0).click();
  }
  
  
});
 


var timer = setInterval(myFunction, 100);
function myFunction() {
 
  if(jQuery('.shopify-payment-button__more-options').length >= 1) {
     jQuery('.alexnova-moreOptions-btn').attr('style', 'visibility: visible!important');
    clearInterval(timer);
    
  }
  //do stuff
};


  
// Credibility Badges
  
Element.prototype.appendAfter = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var imgSrcs = ['https://cdn.shopify.com/s/files/1/0108/5675/9353/files/secure.png?v=1579097871', 'https://cdn.shopify.com/s/files/1/0108/5675/9353/files/shipping.png?v=1579097871', 'https://cdn.shopify.com/s/files/1/0108/5675/9353/files/happiness.png?v=1579097871', 'https://cdn.shopify.com/s/files/1/0108/5675/9353/files/return.png?v=1579097871'];
var badgeTexts = ['Secure Checkout','Free Shipping for Orders $50 or more','100% Satisfaction Guarantee', 'Easy 30-day Returns'];
var imgContainer = document.createElement('div');
imgContainer.innerHTML = '';
imgContainer.className = 'alexnova-img-container';
var y = document.getElementsByClassName('product-message')[0];
if(document.getElementsByClassName('alexnova-img-container').length == 0){
  imgContainer.appendAfter(y);  
}
    
for(var i = 0; i < imgSrcs.length; i++){
                    
    var img = document.createElement('div');
    img.innerHTML = '<div class="alexnova-badge-container"><img src="' + imgSrcs[i] +  '"><span>'+badgeTexts[i]+'</span></div>';
    imgContainer.appendChild(img);
           
    
}
  
  });

  

  
  
  
var x = 0;
var loadtimer = setInterval(function(){
  if(jQuery('.add-to-cart').attr('style') != null || x > 60 || document.readyState == 'complete') {
	
     
  
Element.prototype.appendBefore = function(element) {
    element.parentNode.insertBefore(this, element);
};
  
var timer = setInterval(myFunction, 50);

function myFunction() {
  console.log('..');
  if(jQuery('.add-to-cart').attr('style') != null && jQuery('.add-to-cart').attr('style').includes('cursor')) {
    console.log('here');
    
if(jQuery('.add-to-cart').attr('style').includes('not-allowed')){
   jQuery('.add-to-cart').prop('disabled', false);
    
   }
  
else {
    jQuery('.add-to-cart').addClass('alexnova-add-to-cart');
    
}
    clearInterval(timer);
    return;
  }
  
  else if(jQuery('.add-to-cart').length){
    jQuery('.add-to-cart').addClass('alexnova-add-to-cart');
    clearInterval(timer);
  }
  //do stuff
}
  
jQuery('.add-to-cart').click(function(e){
  //alert('here');
  if(jQuery(this).attr('style').includes('not-allowed')){
   
  var errorPopup = document.createElement('div');
  errorPopup.innerHTML = '<div class="alexnova-pp-message">Please select a variant above.</div>';
  var y = document.getElementsByClassName('add-to-cart');
  if(document.getElementsByClassName('alexnova-pp-message').length == 0){
    errorPopup.appendBefore(y[0]);
  }
      
  e.preventDefault();
   //jQuery(".alexnova-pp-message").effect( "shake", { direction: "right", times: 3, distance: 10}, 200 );  
   shake(document.getElementsByClassName("alexnova-pp-message")[0]);
  }
  
  
});


  
   function checkIfDisabled(){
   
    return setTimeout(function(){ 
     if(jQuery('.alexnova-add-to-cart').length){
      jQuery('.alexnova-moreOptions-btn').removeClass('alexandnova-moreOptions-disabled');
     
       return false;
    }
    else{
     
      jQuery('.alexnova-moreOptions-btn').addClass('alexandnova-moreOptions-disabled');
             return true;
    }
}, 250);
   };

  
  
  
  var shakingElements = [];

function shake(element, magnitude = 12, angular = false) {
  //First set the initial tilt angle to the right (+1) 
  var tiltAngle = 1;

  //A counter to count the number of shakes
  var counter = 1;

  //The total number of shakes (there will be 1 shake per frame)
  var numberOfShakes = 12;

  //Capture the element's position and angle so you can
  //restore them after the shaking has finished
  var startX = 0,
      startY = 0,
      startAngle = 0;

  // Divide the magnitude into 10 units so that you can 
  // reduce the amount of shake by 10 percent each frame
  var magnitudeUnit = magnitude / numberOfShakes;

  //The `randomInt` helper function
  var randomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  //Add the element to the `shakingElements` array if it
  //isn't already there
  if(shakingElements.indexOf(element) === -1) {
    //console.log("added")
    shakingElements.push(element);

    //Add an `updateShake` method to the element.
    //The `updateShake` method will be called each frame
    //in the game loop. The shake effect type can be either
    //up and down (x/y shaking) or angular (rotational shaking).
    if(angular) {
      angularShake();
    } else {
      upAndDownShake();
    }
  }

  //The `upAndDownShake` function
  function upAndDownShake() {

    //Shake the element while the `counter` is less than 
    //the `numberOfShakes`
    if (counter < numberOfShakes) {

      //Reset the element's position at the start of each shake
      element.style.transform = 'translate(' + startX + 'px)';

      //Reduce the magnitude
      magnitude -= magnitudeUnit;

      //Randomly change the element's position
      var randomX = randomInt(-magnitude, magnitude);
      var randomY = randomInt(-magnitude, magnitude);

      element.style.transform = 'translate(' + randomX + 'px)';

      //Add 1 to the counter
      counter += 1;

      requestAnimationFrame(upAndDownShake);
    }

    //When the shaking is finished, restore the element to its original 
    //position and remove it from the `shakingElements` array
    if (counter >= numberOfShakes) {
      element.style.transform = 'translate(' + startX + ', ' + startY + ')';
      shakingElements.splice(shakingElements.indexOf(element), 1);
    }
  }


};

setTimeout(function(){ 
	checkIfDisabled();
      jQuery('.alexnova-moreOptions-btn').attr('style', 'visibility: visible!important');
    }, 200);

  
  function checkIfDisabled(){
   
    return setTimeout(function(){ 
     if(jQuery('.alexnova-add-to-cart').length){
      jQuery('.alexnova-moreOptions-btn').removeClass('alexandnova-moreOptions-disabled');
       return false;
    }
    else{
      jQuery('.alexnova-moreOptions-btn').addClass('alexandnova-moreOptions-disabled');
             return true;
    }
    }, 250);
  }
    
    function clickDisabled(){
setTimeout(function(){ 
if(jQuery('.add-to-cart').attr('style').includes('not-allowed')){
  console.log('disabled');
   jQuery('.add-to-cart').prop('disabled', false);
  jQuery('.add-to-cart').removeClass('alexnova-add-to-cart');
  jQuery(".alexnova-pp-message").show();
   }
else{
    console.log('enabled');
  jQuery('.add-to-cart').addClass('alexnova-add-to-cart');
  jQuery(".alexnova-pp-message").hide();
}
}, 200);
}
    
   setTimeout(function(){ 
     if(jQuery('.alexnova-add-to-cart').length == 1){
      jQuery('.alexandnova-st-item__button').removeClass('alexandnova-st-disabled');
    }
    else{
      jQuery('.alexandnova-st-item__button').addClass('alexandnova-st-disabled');
    }
}, 100);

    
    
    
    
    
var hasInit = document.getElementsByTagName('body')[0].className.includes('alexnova-sticky');
if(!hasInit){
    var timerDrop = setInterval(myFunction2, 100);
function myFunction2() {
    jQuery('body').addClass('alexnova-sticky');
  if(jQuery('#swatch-option1').length == 1) {
    
    Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="alexandnova-st-container" id="alexandnova-st-containerID"> <div class="alexandnova-st-container__outer"> <div class="alexandnova-st-container__inner"> <div class="alexandnova-st-select" id="st-select0"> <span>Size</span> <select> <option></option> </select> </div><div class="alexandnova-st-select" id="st-select1"> <span>Thickness</span> <select> <option></option> </select> </div><div class="alexandnova-st-select" id="st-select2"> <span>Color</span> <select> <option></option> </select> </div><div class="alexandnova-st-item_column__button"><a class="alexandnova-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('alexandnova-st-container').length == 0){
  sticky.appendAfterThis(y[0]);  
  
function populateOptions(select, labels){
  var length = select.options.length;
for (i = length-1; i >= 0; i--) {
  select.options[i] = null;
}
  console.log(select.options.length);
  for(var i =0; i < labels.length; i++){
      var option = document.createElement('OPTION');
      //console.log(i + " " + labels.length);
      var t = document.createTextNode(labels.eq(i).attr('orig-value'));
      option.appendChild(t);
   	  option.id = i;
      select.appendChild(option);
    
      
    	if(labels.eq(i).hasClass('swatch-selected')){
          option.selected = "true";
        }
    
  }
}
  
  function checkIfDisabled(){
    setTimeout(function(){ 
     if(jQuery('.alexnova-add-to-cart').length == 1){
      jQuery('.alexandnova-st-item__button').removeClass('alexandnova-st-disabled');
    }
    else{
      jQuery('.alexandnova-st-item__button').addClass('alexandnova-st-disabled');
    }
}, 200);
    if(window.innerWidth < 768){
      
           var scrTop = jQuery('.add-to-cart').offset().top -200;
       
         }	
      else{
           var scrTop = jQuery('.product-details-wrapper').offset().top;
          jQuery('html, body').animate({
        scrollTop: scrTop - 100
    }, 0);
      }
     
}
  
  jQuery('.single-option-selector > div> label').click(function(e){
   
      e.stopPropagation();
    
    checkIfDisabled();
  });
  
  jQuery('.alexandnova-st-item__button').click(function(){
    
	if(jQuery('.alexandnova-st-item__button').hasClass("alexandnova-st-disabled")){
   	     if(window.innerWidth < 768){
           var scrTop = jQuery('.add-to-cart').offset().top -200;
         }	
      else{
        var scrTop = jQuery('.product-details-wrapper').offset().top;
         
      }
      
      jQuery('html, body').animate({
        scrollTop: scrTop - 100
    }, 200);
        
       
      }
      jQuery('.add-to-cart').eq(0).click();
    
   
  });
  function getLabel(l){
  //console.log('l: ' + l);
  l = l.split(':');
  return l[0];
}
  function updateOptions(){
    
   if(jQuery('#swatch-option1').length == 1){
  //alert('here!');
  jQuery('#st-select0').attr('style' ,'display: flex');
  jQuery('#st-select0 > span').html(getLabel(jQuery('#swatch-option1').attr('option-name')));
  populateOptions(document.getElementById('st-select0').getElementsByTagName('select')[0], jQuery('#swatch-option1 .swatch-selector'));
}
  
if(jQuery('#swatch-option2').length == 1){
  jQuery('#st-select1').attr('style' ,'display: flex');
   jQuery('#st-select1 > span').html(getLabel(jQuery('#swatch-option2').attr('option-name')));
   populateOptions(document.getElementById('st-select1').getElementsByTagName('select')[0], jQuery('#swatch-option2 .swatch-selector'));
}
if(jQuery('#swatch-option3').length == 1){
  jQuery('#st-select2').attr('style' ,'display: flex');
     jQuery('#st-select2 > span').html(getLabel(jQuery('#swatch-option2').attr('option-name')));
   populateOptions(document.getElementById('st-select2').getElementsByTagName('select')[0], jQuery('#swatch-option2 .swatch-selector'));
} 
    
    
    jQuery('#swatch-option1 .swatch-selector').click(function(){
  jQuery('#st-select0 > select').val(jQuery(this).attr('orig-value'));
  
});
jQuery('#swatch-option2 .swatch-selector').click(function(){

  jQuery('#st-select1 > select').val(jQuery(this).attr('orig-value'));
   
});
jQuery('#swatch-option3 .swatch-selector').click(function(){
  
  jQuery('#st-select2 > select').val(jQuery(this).attr('orig-value'));
   
});
    
    
jQuery('#st-select0 > select').change(function(){
  var i = jQuery(this).find(":selected").attr('id');
  jQuery('#swatch-option1 .swatch-selector').eq(i).click();
});
jQuery('#st-select1 > select').change(function(){
 var i = jQuery(this).find(":selected").attr('id');
  jQuery('#swatch-option2 .swatch-selector').eq(i).click();
  
});
jQuery('#st-select2 > select').change(function(){
var i = jQuery(this).find(":selected").attr('id');
  
  jQuery('#swatch-option1 .swatch-selector').eq(i).click();
  
});
  }
  
  updateOptions();
  setTimeout(function(){ 
     if(jQuery('.alexnova-add-to-cart').length == 1){
      jQuery('.alexandnova-st-item__button').removeClass('alexandnova-st-disabled');
    }
    else{
      jQuery('.alexandnova-st-item__button').addClass('alexandnova-st-disabled');
    }
}, 200);
};
    
   
    
jQuery('.swatch-selector').click(function(){
  //clickDisabled();
   setTimeout(function(){ 
checkIfDisabled();
  updateOptions();
}, 50);
   
});

    
    
 // checkIfDisabled();
       
var mc = window.matchMedia("(min-width: 750px)");
        mc.addListener(slideshow);    
        
    var elem = document.getElementById("alexandnova-st-containerID");      
    function slideshow() {
        if (mc.matches) { 
                elem.style.bottom="0px";
            } else {
           elem.style.bottom="0px";
            }
        }
        
     function slideHide() {           
        elem.style.bottom="-90px";
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > 100) {
       slideshow();
            
    } else {
  
        slideHide();
        
    }
});
                  
  
    clearInterval(timerDrop);
  }
  //do stuff
}
    };
    
    
    
    
clearInterval(loadtimer);
  }
x++;
}, 50);

/*
jQuery( window ).load(function() {
   setTimeout(function(){ 
checkIfDisabled();
  jQuery('.alexnova-moreOptions-btn').attr('style', 'visibility: visible!important');
}, 200);
  
  
  function checkIfDisabled(){
   
    return setTimeout(function(){ 
     if(jQuery('.alexnova-add-to-cart').length){
      jQuery('.alexnova-moreOptions-btn').removeClass('alexandnova-moreOptions-disabled');
       return false;
    }
    else{
      jQuery('.alexnova-moreOptions-btn').addClass('alexandnova-moreOptions-disabled');
             return true;
    }
    }, 250);
  }
});
*/
/*STICKY*/

jQuery( document ).ready(function() {

});
    
window.onload = function(){
    
   setTimeout(function(){ 
     if(jQuery('.alexnova-add-to-cart').length == 1){
      jQuery('.alexandnova-st-item__button').removeClass('alexandnova-st-disabled');
    }
    else{
      jQuery('.alexandnova-st-item__button').addClass('alexandnova-st-disabled');
    }
}, 100);
} ;

}